import DetailPermintaanPrelim from './DetailPermintaanPrelim';

export default DetailPermintaanPrelim;
